module.exports = __webpack_public_path__ + "static/media/27-2.83f5b491.mp3";